import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-card-online",
  "use": "svg-icon-card-online-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"svg-icon-card-online\"><g fill-rule=\"nonzero\" fill=\"none\"><path d=\"M10.1 19.8c-5.3 0-9.6-4.3-9.6-9.6S4.8.6 10.1.6s9.6 4.3 9.6 9.6-4.3 9.6-9.6 9.6z\" fill=\"#8AC440\" /><path d=\"M9.1 14.6c-.3 0-.6-.1-.9-.4L5 11.1c-.5-.5-.5-1.3 0-1.8s1.3-.5 1.8 0L9 11.5l3.6-4.3c.4-.5 1.2-.6 1.7-.2.5.4.6 1.2.2 1.8L10 14.2c-.2.2-.5.4-.9.4z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol